import type { MediaItem } from '../types/media';

export const mediaList: MediaItem[] = [
  {
    id: 'm-001',
    title: '星海远征',
    type: 'movie',
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20movie%20poster%20with%20a%20lone%20astronaut%20facing%20a%20giant%20glowing%20planet%2C%20deep%20space%20atmosphere%2C%20dramatic%20red%20and%20orange%20nebula%2C%20epic%20film%20key%20art%2C%20high%20contrast%2C%20no%20text&width=600&height=900&seq=mc-poster-001&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Epic%20space%20scene%20with%20glowing%20planet%20and%20nebula%20clouds%2C%20warm%20orange%20and%20deep%20teal%20tones%2C%20cinematic%20wide%20shot%2C%20dramatic%20lighting%2C%20sci-fi%20film%20still&width=1600&height=900&seq=mc-back-001&orientation=landscape',
    year: 2026,
    region: '中国大陆',
    genres: ['科幻', '冒险', '动作'],
    rating: 8.9,
    director: '陈墨白',
    cast: ['林振宇', '苏晚晴', '赵启明'],
    synopsis: '当人类最后的星际方舟偏离航线，一支临时组建的远征队需要穿越未知的星海，在燃料耗尽之前找到那颗传说中的宜居星球。亲情、信念与牺牲在真空之中被无限放大。',
    popularity: 9876,
    episodes: '128 分钟',
    tagline: '穿越星海，只为回家',
  },
  {
    id: 'm-002',
    title: '无声告白',
    type: 'movie',
    poster: 'https://readdy.ai/api/search-image?query=Emotional%20drama%20movie%20poster%20with%20a%20single%20silhouette%20by%20a%20rainy%20window%2C%20moody%20blue%20and%20amber%20light%2C%20minimal%20artistic%20composition%2C%20cinematic%20key%20art%2C%20no%20text&width=600&height=900&seq=mc-poster-002&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Moody%20rainy%20city%20street%20at%20night%20with%20warm%20street%20lamps%20reflecting%20on%20wet%20ground%2C%20cinematic%20drama%20film%20still%2C%20soft%20bokeh&width=1600&height=900&seq=mc-back-002&orientation=landscape',
    year: 2025,
    region: '中国大陆',
    genres: ['剧情', '家庭'],
    rating: 8.4,
    director: '周砚',
    cast: ['许知言', '何书宁', '张一凡'],
    synopsis: '一位沉默寡言的父亲与多年未归的女儿，在一场葬礼之后被迫重新面对彼此。那些从未说出口的爱，究竟该如何被听见。',
    popularity: 7320,
    episodes: '116 分钟',
    tagline: '有些爱，从未说出口',
  },
  {
    id: 'm-003',
    title: '都市夜归人',
    type: 'movie',
    poster: 'https://readdy.ai/api/search-image?query=Crime%20thriller%20movie%20poster%20with%20a%20shadowy%20figure%20in%20a%20neon%20lit%20alley%2C%20teal%20and%20orange%20neon%20signs%2C%20tense%20urban%20atmosphere%2C%20cinematic%20key%20art%2C%20no%20text&width=600&height=900&seq=mc-poster-003&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Rainy%20neon-lit%20city%20alley%20at%20night%20with%20reflective%20pavement%20and%20glowing%20signs%2C%20crime%20thriller%20cinematic%20film%20still&width=1600&height=900&seq=mc-back-003&orientation=landscape',
    year: 2025,
    region: '中国香港',
    genres: ['犯罪', '悬疑', '动作'],
    rating: 8.1,
    director: '麦嘉骏',
    cast: ['程子谦', '关雨桐', '岑默'],
    synopsis: '一名夜班出租车司机意外卷入一连串连环案件，他载过的每一位乘客都可能是真凶。在黎明到来之前，他必须找出真相。',
    popularity: 8540,
    episodes: '134 分钟',
    tagline: '每一程，都藏着秘密',
  },
  {
    id: 'm-004',
    title: '长安幻夜',
    type: 'movie',
    poster: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20fantasy%20movie%20poster%20with%20lantern-lit%20palace%20rooftops%20and%20a%20cloaked%20figure%2C%20warm%20gold%20and%20crimson%20tones%2C%20cinematic%20key%20art%2C%20no%20text&width=600&height=900&seq=mc-poster-004&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20city%20at%20night%20filled%20with%20hanging%20red%20lanterns%2C%20misty%20rooftops%2C%20fantasy%20film%20still%2C%20warm%20golden%20light&width=1600&height=900&seq=mc-back-004&orientation=landscape',
    year: 2026,
    region: '中国大陆',
    genres: ['奇幻', '古装', '动作'],
    rating: 8.7,
    director: '顾长风',
    cast: ['白景行', '云舒', '南宫彻'],
    synopsis: '盛唐长安的一个夜晚，一名能看见妖物的术士与一位失去记忆的神秘女子，卷入了改写整座城池命运的阴谋。花灯之下，人与妖的界限开始模糊。',
    popularity: 9120,
    episodes: '142 分钟',
    tagline: '一夜长安，百鬼夜行',
  },
  {
    id: 'm-005',
    title: '追风少年',
    type: 'movie',
    poster: 'https://readdy.ai/api/search-image?query=Inspiring%20sports%20movie%20poster%20with%20a%20young%20runner%20silhouette%20against%20a%20golden%20sunset%20track%2C%20warm%20orange%20sky%2C%20dynamic%20motion%2C%20cinematic%20key%20art%2C%20no%20text&width=600&height=900&seq=mc-poster-005&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Running%20track%20at%20golden%20hour%20with%20warm%20sunset%20sky%20and%20lens%20flare%2C%20inspiring%20sports%20film%20still%2C%20dynamic%20composition&width=1600&height=900&seq=mc-back-005&orientation=landscape',
    year: 2025,
    region: '中国大陆',
    genres: ['运动', '励志', '剧情'],
    rating: 8.2,
    director: '方励',
    cast: ['徐向阳', '安小满', '曾宇'],
    synopsis: '小镇少年为了兑现与母亲的约定，从泥泞的乡间小路一路跑向全国赛场。风会记得每一个不肯停下的人。',
    popularity: 6210,
    episodes: '110 分钟',
    tagline: '风记得每一次奔跑',
  },
  {
    id: 'm-006',
    title: '迷雾档案',
    type: 'movie',
    poster: 'https://readdy.ai/api/search-image?query=Dark%20mystery%20movie%20poster%20with%20a%20foggy%20forest%20and%20a%20flashlight%20beam%2C%20cold%20desaturated%20tones%2C%20suspenseful%20atmosphere%2C%20cinematic%20key%20art%2C%20no%20text&width=600&height=900&seq=mc-poster-006&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Foggy%20pine%20forest%20at%20dawn%20with%20mysterious%20light%20rays%20through%20mist%2C%20thriller%20film%20still%2C%20cold%20moody%20tones&width=1600&height=900&seq=mc-back-006&orientation=landscape',
    year: 2026,
    region: '中国大陆',
    genres: ['悬疑', '剧情'],
    rating: 8.5,
    director: '沈默',
    cast: ['陆则言', '米雪', '韩东'],
    synopsis: '一份被尘封二十年的档案重新浮出水面，退休警探决定追查到底。迷雾背后，真相远比想象中更令人不安。',
    popularity: 7980,
    episodes: '126 分钟',
    tagline: '真相，藏在雾的尽头',
  },
  {
    id: 't-001',
    title: '山海长歌',
    type: 'tv',
    poster: 'https://readdy.ai/api/search-image?query=Grand%20ancient%20Chinese%20epic%20tv%20drama%20poster%20with%20mountain%20range%20and%20a%20warrior%20on%20a%20cliff%2C%20dramatic%20clouds%2C%20teal%20and%20gold%20tones%2C%20cinematic%20key%20art%2C%20no%20text&width=600&height=900&seq=mc-poster-007&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Epic%20ancient%20Chinese%20mountains%20above%20a%20sea%20of%20clouds%20at%20sunrise%2C%20costume%20drama%20film%20still%2C%20sweeping%20landscape&width=1600&height=900&seq=mc-back-007&orientation=landscape',
    year: 2026,
    region: '中国大陆',
    genres: ['古装', '奇幻', '爱情'],
    rating: 8.8,
    director: '许川',
    cast: ['洛清欢', '萧亦然', '慕容雪'],
    synopsis: '背负部族使命的少女与流落人间的上古神将，在乱世中并肩而行。他们要在山河破碎之前，唱响最后一首长歌。',
    popularity: 10240,
    episodes: '全 40 集',
    tagline: '山河为卷，长歌当剑',
  },
  {
    id: 't-002',
    title: '归途有风',
    type: 'tv',
    poster: 'https://readdy.ai/api/search-image?query=Warm%20family%20drama%20tv%20poster%20with%20a%20countryside%20house%20and%20golden%20wheat%20field%2C%20soft%20sunlight%2C%20nostalgic%20tones%2C%20cinematic%20key%20art%2C%20no%20text&width=600&height=900&seq=mc-poster-008&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Golden%20wheat%20field%20with%20a%20small%20farmhouse%20at%20sunset%2C%20warm%20nostalgic%20family%20drama%20still%2C%20soft%20light&width=1600&height=900&seq=mc-back-008&orientation=landscape',
    year: 2025,
    region: '中国大陆',
    genres: ['家庭', '剧情', '都市'],
    rating: 8.3,
    director: '林向阳',
    cast: ['周慧兰', '郑昊', '李念'],
    synopsis: '在大城市打拼多年的三兄妹因为老宅拆迁回到故乡，重新拾起被时间冲淡的亲情。归途之上，风一直在吹。',
    popularity: 6890,
    episodes: '全 36 集',
    tagline: '回家的路，风一直记得',
  },
  {
    id: 't-003',
    title: '黑白之间',
    type: 'tv',
    poster: 'https://readdy.ai/api/search-image?query=Crime%20drama%20tv%20poster%20with%20a%20detective%20silhouette%20against%20a%20checkerboard%20light%20and%20shadow%2C%20high%20contrast%20noir%20tones%2C%20cinematic%20key%20art%2C%20no%20text&width=600&height=900&seq=mc-poster-009&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Empty%20interrogation%20room%20with%20harsh%20overhead%20light%20and%20long%20shadows%2C%20noir%20crime%20drama%20still%2C%20high%20contrast&width=1600&height=900&seq=mc-back-009&orientation=landscape',
    year: 2026,
    region: '中国大陆',
    genres: ['犯罪', '悬疑', '剧情'],
    rating: 8.6,
    director: '高城',
    cast: ['秦峥', '白露', '罗晋安'],
    synopsis: '一名坚持原则的检察官与一名游走灰色地带的刑警，在同一桩案件中不断交锋。正义的边界，究竟在哪里。',
    popularity: 8760,
    episodes: '全 38 集',
    tagline: '是非之间，寸步不让',
  },
  {
    id: 't-004',
    title: '春日告白',
    type: 'tv',
    poster: 'https://readdy.ai/api/search-image?query=Romantic%20youth%20drama%20poster%20with%20cherry%20blossoms%20and%20two%20students%20under%20a%20tree%2C%20soft%20pink%20and%20warm%20light%2C%20fresh%20romance%20atmosphere%2C%20cinematic%20key%20art%2C%20no%20text&width=600&height=900&seq=mc-poster-010&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Cherry%20blossom%20avenue%20in%20spring%20with%20falling%20petals%20and%20warm%20sunlight%2C%20romantic%20youth%20drama%20still%2C%20soft%20pastel%20tones&width=1600&height=900&seq=mc-back-010&orientation=landscape',
    year: 2025,
    region: '中国大陆',
    genres: ['爱情', '青春', '都市'],
    rating: 8.0,
    director: '苏晚',
    cast: ['温言', '顾南枝', '夏之遥'],
    synopsis: '错过了一整个春天的两个人，在樱花再次盛开时重逢。有些告白迟到了很久，却依然刚刚好。',
    popularity: 7540,
    episodes: '全 30 集',
    tagline: '迟到的告白，恰逢其时',
  },
  {
    id: 't-005',
    title: '千灯之城',
    type: 'tv',
    poster: 'https://readdy.ai/api/search-image?query=Fantasy%20tv%20poster%20with%20a%20floating%20lantern-lit%20city%20above%20the%20clouds%2C%20magical%20glowing%20lights%2C%20purple%20gold%20fantasy%20tones%2C%20cinematic%20key%20art%2C%20no%20text&width=600&height=900&seq=mc-poster-011&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Fantasy%20floating%20city%20illuminated%20by%20thousands%20of%20lanterns%20above%20glowing%20clouds%2C%20magical%20night%20scene%2C%20cinematic%20still&width=1600&height=900&seq=mc-back-011&orientation=landscape',
    year: 2026,
    region: '中国大陆',
    genres: ['奇幻', '古装', '冒险'],
    rating: 8.4,
    director: '白临川',
    cast: ['叶星阑', '苏梨', '陆昭'],
    synopsis: '传说中漂浮在云端之上的千灯之城每十年才现世一次。少年为寻找失踪的师父，踏上这座以灯火为命的奇幻之城。',
    popularity: 8110,
    episodes: '全 34 集',
    tagline: '千灯不灭，传说长明',
  },
  {
    id: 't-006',
    title: '逆流而上',
    type: 'tv',
    poster: 'https://readdy.ai/api/search-image?query=Corporate%20workplace%20drama%20poster%20with%20a%20confident%20young%20executive%20in%20a%20modern%20glass%20office%2C%20cool%20blue%20and%20warm%20accent%20tones%2C%20cinematic%20key%20art%2C%20no%20text&width=600&height=900&seq=mc-poster-012&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Modern%20glass%20skyscraper%20office%20at%20dusk%20with%20city%20skyline%2C%20workplace%20drama%20still%2C%20cool%20cinematic%20tones&width=1600&height=900&seq=mc-back-012&orientation=landscape',
    year: 2025,
    region: '中国大陆',
    genres: ['都市', '职场', '剧情'],
    rating: 8.1,
    director: '程远',
    cast: ['莫亦辰', '沈青禾', '丁淮'],
    synopsis: '一场突如其来的并购让公司陷入危机，年轻的项目经理必须在权力与理想之间做出选择。逆流之中，有人沉没，有人突围。',
    popularity: 6650,
    episodes: '全 32 集',
    tagline: '逆流之上，方见锋芒',
  },
  {
    id: 'v-001',
    title: '极限挑战营',
    type: 'variety',
    poster: 'https://readdy.ai/api/search-image?query=Energetic%20variety%20show%20poster%20with%20colorful%20outdoor%20obstacle%20course%20and%20dynamic%20silhouettes%2C%20bold%20orange%20and%20teal%20tones%2C%20playful%20key%20art%2C%20no%20text&width=600&height=900&seq=mc-poster-013&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Entertainment%20show%20stage%20with%20bright%20colorful%20lights%20and%20confetti%2C%20energetic%20atmosphere%2C%20vibrant%20zest%20still&width=1600&height=900&seq=mc-back-013&orientation=landscape',
    year: 2026,
    region: '中国大陆',
    genres: ['真人秀', '竞技', '户外'],
    rating: 8.2,
    director: '综艺组',
    cast: ['雷大力', '花小满', '陆一鸣'],
    synopsis: '八位嘉宾被投放到荒野营地，在极限环境中完成一个又一个不可能的任务。谁能笑到最后，谁又会被淘汰出局。',
    popularity: 8420,
    episodes: '更新至 12 期',
    tagline: '挑战极限，笑到最后',
  },
  {
    id: 'v-002',
    title: '星光音乐会',
    type: 'variety',
    poster: 'https://readdy.ai/api/search-image?query=Music%20show%20poster%20with%20a%20stage%20microphone%20and%20glowing%20spotlights%2C%20warm%20amber%20and%20deep%20teal%20tones%2C%20elegant%20concert%20key%20art%2C%20no%20text&width=600&height=900&seq=mc-poster-014&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Concert%20stage%20with%20dramatic%20spotlights%20and%20glowing%20crowd%20in%20the%20dark%2C%20music%20show%20still%2C%20warm%20amber%20light&width=1600&height=900&seq=mc-back-014&orientation=landscape',
    year: 2025,
    region: '中国大陆',
    genres: ['音乐', 'live', '舞台'],
    rating: 8.5,
    director: '音乐频道',
    cast: ['夏语', '周澈', '林晚星'],
    synopsis: '每期邀请不同风格的音乐人同台演绎，用一场场现场演出呈现华语音乐最真实的温度与力量。',
    popularity: 7890,
    episodes: '更新至 9 期',
    tagline: '让每一次现场都值得',
  },
  {
    id: 'v-003',
    title: '美食奇遇记',
    type: 'variety',
    poster: 'https://readdy.ai/api/search-image?query=Food%20travel%20show%20poster%20with%20steaming%20street%20food%20stall%20and%20warm%20lanterns%2C%20appetizing%20warm%20colors%2C%20cozy%20documentary%20key%20art%2C%20no%20text&width=600&height=900&seq=mc-poster-015&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Bustling%20night%20market%20street%20food%20with%20glowing%20stalls%20and%20warm%20steam%2C%20food%20documentary%20still%2C%20cozy%20atmosphere&width=1600&height=900&seq=mc-back-015&orientation=landscape',
    year: 2026,
    region: '中国大陆',
    genres: ['美食', '旅行', '纪实'],
    rating: 8.7,
    director: '寻味组',
    cast: ['阿岩', '小厨娘', '老李头'],
    synopsis: '跟随三位美食猎人走遍大江南北，在每一个不起眼的街角寻找最地道的味道，也寻找味道背后的人情故事。',
    popularity: 7120,
    episodes: '更新至 15 期',
    tagline: '人间烟火，最抚人心',
  },
  {
    id: 'v-004',
    title: '快乐大冲关',
    type: 'variety',
    poster: 'https://readdy.ai/api/search-image?query=Fun%20game%20show%20poster%20with%20colorful%20inflatable%20obstacles%20and%20bright%20balloons%2C%20joyful%20saturated%20colors%2C%20playful%20variety%20key%20art%2C%20no%20text&width=600&height=900&seq=mc-poster-016&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Colorful%20indoor%20game%20show%20arena%20with%20bright%20lights%20and%20balloons%2C%20cheerful%20variety%20still%2C%20vivid%20saturated%20colors&width=1600&height=900&seq=mc-back-016&orientation=landscape',
    year: 2025,
    region: '中国大陆',
    genres: ['游戏', '喜剧', '竞技'],
    rating: 7.9,
    director: '快乐组',
    cast: ['胖虎', '喜宝', '阿乐'],
    synopsis: '全民参与的大型闯关游戏节目，笑点密集、节奏轻快，用最简单的方式带来最纯粹的快乐。',
    popularity: 5980,
    episodes: '更新至 20 期',
    tagline: '快乐，就是冲过去',
  },
  {
    id: 'v-005',
    title: '密室逃脱王',
    type: 'variety',
    poster: 'https://readdy.ai/api/search-image?query=Reality%20escape%20room%20show%20poster%20with%20a%20dim%20mysterious%20corridor%20and%20glowing%20door%2C%20teal%20and%20amber%20tones%2C%20suspenseful%20key%20art%2C%20no%20text&width=600&height=900&seq=mc-poster-017&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Dark%20mysterious%20escape%20room%20interior%20with%20glowing%20clues%20and%20flickering%20lights%2C%20reality%20show%20still%2C%20tense%20atmosphere&width=1600&height=900&seq=mc-back-017&orientation=landscape',
    year: 2026,
    region: '中国大陆',
    genres: ['推理', '真人秀', '悬疑'],
    rating: 8.3,
    director: '迷城组',
    cast: ['推理君', '小谜', '老K'],
    synopsis: '顶级解谜玩家组成战队，挑战节目组精心设计的巨型实景密室。九十分钟内，他们能否解开所有谜题。',
    popularity: 8230,
    episodes: '更新至 11 期',
    tagline: '线索就在眼前',
  },
  {
    id: 'v-006',
    title: '青春创造营',
    type: 'variety',
    poster: 'https://readdy.ai/api/search-image?query=Youth%20talent%20show%20poster%20with%20a%20glowing%20stage%20and%20dancers%20silhouette%2C%20vibrant%20pink%20and%20orange%20stage%20light%2C%20energetic%20key%20art%2C%20no%20text&width=600&height=900&seq=mc-poster-018&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Youth%20talent%20competition%20stage%20with%20vibrant%20lights%20and%20performing%20contestants%2C%20energetic%20variety%20still%2C%20bright%20colors&width=1600&height=900&seq=mc-back-018&orientation=landscape',
    year: 2025,
    region: '中国大陆',
    genres: ['选秀', '音乐', '青春'],
    rating: 8.1,
    director: '燃烧团',
    cast: ['青春导师', '少年们', '台下星光'],
    synopsis: '一百位怀揣梦想的少年同台竞技，用汗水与舞台证明自己。成团的路上，每一次登台都是新的开始。',
    popularity: 7460,
    episodes: '更新至 13 期',
    tagline: '以青春之名，向光而行',
  },
];